import {
    ADMIN_TICKET_SETTINGS_FETCH_PENDING,
    ADMIN_TICKET_SETTINGS_SELECT_GROUP,
    ADMIN_TICKET_SETTINGS_UPDATE_PENDING
} from '../../actions/admin/actionAdminTicketSettings';
import get from 'get-value';
import {sparePartsWebsocketCommands} from '../../constants/sparePartsWebsocketCommands';
import {techDocWebsocketCommands} from '../../constants/techDocWebsocketCommands';
import {claimsWebsocketCommands} from '../../constants/claimsWebsocketCommands';

export const adminTicketSettings = (state = {
    isLoading: true,
    ticketSettings: {},
    selectedCountryGroup: ''
}, action) => {
    switch (action.type) {
        case ADMIN_TICKET_SETTINGS_SELECT_GROUP:
            return Object.assign({}, state, {selectedCountryGroup: action.payload});
        case ADMIN_TICKET_SETTINGS_FETCH_PENDING:
            return Object.assign({}, state, {isLoading: true, ticketSettings: {}});
        case ADMIN_TICKET_SETTINGS_UPDATE_PENDING:
            return Object.assign({}, state, {isLoading: true, ticketSettings: {}});
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_TICKET_SETTINGS_SEND:
        case techDocWebsocketCommands.TECH_DOC_TICKET_SETTINGS_SEND:
        case claimsWebsocketCommands.CLAIMS_TICKET_SETTINGS_SEND: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {
                isLoading: false,
                ticketSettings: get(action, 'payload.settings', {default: {}}),
                correlationId
            });
        }
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_TICKET_SETTINGS_ERROR:
        case techDocWebsocketCommands.TECH_DOC_TICKET_SETTINGS_ERROR:
        case claimsWebsocketCommands.CLAIMS_TICKET_SETTINGS_ERROR:
        case sparePartsWebsocketCommands.SPARE_PARTS_ORDERS_TICKET_SETTINGS_SEND_ERROR:
        case techDocWebsocketCommands.TECH_DOC_TICKET_SETTINGS_SEND_ERROR:
        case claimsWebsocketCommands.CLAIMS_TICKET_SETTINGS_SEND_ERROR: {
            const {correlationId} = action.payload;
            if (correlationId < state.correlationId) {
                return state;
            }
            return Object.assign({}, state, {isLoading: false, ticketSettings: {}, correlationId});
        }
        default:
            return state;
    }
};

